import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getZone() {
      return getState().zone;
    },
    isZoneRetrievalRequestFailure() {
      return getState().request.isFailure;
    },
    isZoneRetrievalRequestPending() {
      return getState().request.isPending;
    },
    isZoneRetrievalRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
